// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__TWlzu","col":"styles_col__1J_g5"};